// extracted by mini-css-extract-plugin
module.exports = {"molecule-action-banner-search-form-container":"styles_molecule-action-banner-search-form-container__SpV2n"};